import React from 'react'
import { FileRetention, RetentionResource } from '../../../models/RetentionPolicy'
const EMPTY_FIELD_MESSAGE = '-'

export const RetentionPolicyFileResourceBody: React.FC<{ retentionResource: RetentionResource }> = ({ retentionResource }) => {
  const resource = retentionResource as FileRetention
  return (
    <>
      <div>
        <div>File kind</div>
        <div aria-label='Resource type'>{resource.config?.kind || EMPTY_FIELD_MESSAGE}</div>
      </div>
    </>
  )
}
